import { render, staticRenderFns } from "./EmployeeProfile.vue?vue&type=template&id=c4818ac0"
import script from "./EmployeeProfile.vue?vue&type=script&lang=js"
export * from "./EmployeeProfile.vue?vue&type=script&lang=js"
import style0 from "./EmployeeProfile.vue?vue&type=style&index=0&id=c4818ac0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports